<script setup lang="ts">
import Skeleton from '@/shared/ui/Skeleton/index';

const isMobile: boolean = useIsMobile();
</script>

<template>
  <div :class="['services-section-skeleton', { _mobile: isMobile }]">
    <Skeleton width="100%" :height="isMobile ? '183px' : '146px'" />
    <Skeleton
      :class="['services-section-skeleton__button', { _mobile: isMobile }]"
      :width="isMobile ? '100%' : '235px'"
      height="45px"
    />
  </div>
</template>

<style lang="less" scoped>
.services-section-skeleton {
  .flex-column(@size-x8);
  .box-shadow();

  padding: @size-x8;

  &._mobile {
    padding: @size-x5;
  }

  &__button:not(._mobile) {
    margin-left: auto;
  }
}
</style>
